import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from '@/components/Button/Button.vue';
import { useI18n } from 'vue-i18n';
import Flex from '@/components/Flex/Flex.vue';
import { useSendOtpCode } from './composables/useSendOtpCode';
import { onBeforeMount, onUnmounted, ref } from 'vue';
import { SMS_RESEND_TIME } from '@/constants';
import { toMMSS } from './utils/toMMSS';
import { useToast } from '@/composables/useToast';
import { useCountdownStorage } from '@/features/SmsCodeVerification/components/SendOtpForm/composables/useCountdownStorage';


export default /*@__PURE__*/_defineComponent({
  __name: 'SendOtpForm',
  props: {
    usersPhone: {}
  },
  emits: ["success", "expired"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const { showToast } = useToast();

const emit = __emit;

const props = __props;

const { getRemainingTime, setNewTime } = useCountdownStorage(props.usersPhone);

const { mutateAsync: sendOTPCodeMutation, isPending: OTPCodeSendLoading } =
  useSendOtpCode(props.usersPhone);

const remainingTime = ref(0);
let timer = -1;

onBeforeMount(() => {
  if (!getRemainingTime()) {
    return;
  }

  startTimer(getRemainingTime());
  emit('success');
});

const startTimer = (seconds: number) => {
  remainingTime.value = seconds;

  if (!seconds) {
    return;
  }

  timer = setInterval(() => {
    remainingTime.value -= 1;

    if (remainingTime.value <= 0) {
      emit('expired');
      clearInterval(timer);
    }
  }, 1000);
};

onUnmounted(() => {
  clearInterval(timer);
});

const sendOtpCode = async () => {
  await sendOTPCodeMutation()
    .then(() => {
      startTimer(SMS_RESEND_TIME);
      setNewTime();

      emit('success');
    })
    .catch(() => {
      showToast(t('general.response_errors.GENERIC_ERROR_title'), {
        type: 'error',
      });
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Flex, {
    direction: "column",
    align: "stretch",
    gap: 2
  }, {
    default: _withCtx(() => [
      _createVNode(Button, {
        label: _unref(t)('sign_in.action'),
        disabled: !!remainingTime.value || _unref(OTPCodeSendLoading),
        onClick: sendOtpCode
      }, null, 8, ["label", "disabled"]),
      _createElementVNode("span", {
        class: _normalizeClass(["resend-code md-typescale-body-large", !remainingTime.value ? 'hidden' : ''])
      }, _toDisplayString(_unref(t)('sign_in.resend_code')) + " " + _toDisplayString(_unref(toMMSS)(remainingTime.value)), 3)
    ]),
    _: 1
  }))
}
}

})